import fichoAzul from '../imgs/fichos/Ficho-azul.png';
import fichoRojo from '../imgs/fichos/Ficho-rojo.png';
import fichoVerde from '../imgs/fichos/Ficho-verde.png';
import fichoAmarillo from '../imgs/fichos/Ficho-amarillo.png';

let puntuaciones = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

let puntuaciones2 = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

let puntuaciones3 = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

let puntuaciones4 = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

let puntuaciones5 = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

let puntuaciones6 = [
    {
        "ficho": "azul",
        "puntuacion": 0,
        "img": fichoAzul,
        "preguntas": 0

    },
    {
        "ficho": "rojo",
        "puntuacion": 0,
        "img": fichoRojo,
        "preguntas": 0
    },
    {
        "ficho": "verde",
        "puntuacion": 0,
        "img": fichoVerde,
        "preguntas": 0
    },
    {
        "ficho": "rosa",
        "puntuacion": 0,
        "img": fichoAmarillo,
        "preguntas": 0
    },
]

export { puntuaciones, puntuaciones2, puntuaciones3, puntuaciones4, puntuaciones5, puntuaciones6 };